module.exports = function transitions({ addUtilities }) {
  const newUtilities = {
    '.type-scale-5': { 'font-size': '1.383rem' },
    '.type-scale-4': { 'font-size': '1.296rem' },
    '.type-scale-3': { 'font-size': '1.215rem' },
    '.type-scale-2': { 'font-size': '1.138rem' },
    '.type-scale-1': { 'font-size': '1.067rem' },
    '.type-scale-0': { 'font-size': '1rem' },
    '.type-scale-n1': { 'font-size': '0.937rem' },
    '.type-scale-n2': { 'font-size': '0.878rem' },
    '.type-scale-n3': { 'font-size': '0.823rem' },
    '.type-scale-n4': { 'font-size': '0.772rem' },
    '.type-scale-n5': { 'font-size': '0.723rem' }
  }

  addUtilities(newUtilities)
}
